import SchoolYearData from './SchoolYearData';

export default SchoolYearData;
